export const fr = {
  opportunityRequestsPage: {
    page_title_requests: 'Mes demandes',
    page_title_events: 'Mes événements',

    requests: {
      title: "Demandes d'événements",
      subtext: 'Gérez vos demandes d’événements',
      empty_state: {
        title: 'Aucune demande pour le moment',
        description:
          "Il semble que vous n'ayez pas encore soumis de demandes d'événements.\nSoumettez une nouvelle demande pour commencer à faire du bénévolat !",
      },
    },
    created_events: {
      title: 'Mes événements créés',
      subtext: 'Gérez vos événements créés',
      empty_state: {
        title: 'Aucun événement créé',
        description: "Il semble que vous n'ayez pas encore créé d'événement.",
      },
      search_placeholder: 'Rechercher des événements créés',

    },
    status_labels: {
      submitted: 'En révision',
      in_review: 'En révision',
      in_progress: 'En cours',
      pending_your_feedback: 'En attente de votre retour',
      fulfilled: 'Réalisée',
      opportunity_completed: 'Evénement terminée',
      cancelled: 'Annulée',
      published: 'Publiée',
      draft: 'Brouillon',
    },
    company_requests: {
      title: "Demandes d'événements",
      subtext: 'Gérez les demandes de votre entreprise',
      empty_state: {
        title: 'Aucune demande pour le moment',
        description:
          "Il semble que vous n'ayez pas encore soumis de demandes d'événements.\nSoumettez une nouvelle demande pour commencer à faire du bénévolat !",
      },
    },
    table: {
      columns: {
        submitted: 'Soumis',
        status: 'Statut',
        last_updated: 'Dernière mise à jour',
        details: 'Détails',
        name: 'Nom',
        date: 'Date',
        dates: 'Dates',
        nonprofit: 'Association',
        submitted_by: 'Soumis par',
        role: 'Rôle',
        co_requesters: 'Co-organisateur',
        company: 'Entreprise',
        view_opportunity: "Voir l'événement",
      },
      details: {
        target_audience: 'Public cible',
        dates: 'Dates',
        location: 'Lieu',
        attendees: 'Participants',
        times_of_day: 'Moment(s) de la journée',
        additional_details: 'Détails supplémentaires',
      },
    },
    actions: {
      view_opportunity: "Voir l'événement",
      edit_request: 'Modifier la demande',
      cancel_request: 'Annuler la demande',
      role_primary: 'Principal',
      role_co_requester: 'Co-organisateur',
      edit_opportunity: "Modifier l'événement",
      delete: 'Supprimer',
      cancel_event: "Annuler l'événement",
      no_actions: 'Aucune action disponible',
      create_new: 'Créer une nouvelle événement',
      new_request: "Nouvelle demande",
    },
    status: {
      all: 'Tous',
      submitted: 'Soumis',
      in_review: 'En révision',
      in_progress: 'En cours',
      pending_your_feedback: 'En attente de votre retour',
      fulfilled: 'Réalisée',
      opportunity_completed: 'Evénement terminée',
      cancelled: 'Annulée',
      published: 'Publiée',
      draft: 'Brouillon',
    },
    toggle: {
      attending: 'Participant',
      created: 'Créé',
    },
    cancel_modal: {
      title: "Annuler la demande d'événement",
      message: "Êtes-vous sûr de vouloir annuler votre demande d'événement ?",
      buttons: {
        confirm: 'Oui',
        cancel: 'Non',
      },
    },
    confirmDeleteModal: {
      title: "Supprimer l'événement",
      message: "Êtes-vous sûr de vouloir supprimer votre demande d'événement ?",
      delete_progress_warning:
        'Toute progression sera définitivement supprimée.',
      buttons: {
        confirm: 'Oui',
        cancel: 'Non',
      },
    },
    confirmCancelModal: {
      title: "Annuler l'événement",
      message: "Êtes-vous sûr de vouloir annuler votre demande d'événement ?",
      cancel_event_warning:
        'Cet événement a {{reservations}} bénévole(s) inscrit(s).',
      buttons: {
        confirm: 'Oui',
        cancel: 'Non',
      },
    },
    created_events_table: {
      columns: {
        name: 'Nom',
        date: 'Date',
        nonprofit: 'Association',
        status: 'Statut',
      },
      status: {
        cancelled: 'Annulé',
        published: 'Publié',
        draft: 'Brouillon',
        duplicate_opportunity: 'Dupliquer l’événement',
      },
      actions: {
        edit_opportunity: "Modifier l'événement",
        delete: 'Supprimer',
        cancel_event: "Annuler l'événement",
      },
    },
    delete_unpublished_modal: {
      title: "Supprimer l'événement",
      message: "Êtes-vous sûr de vouloir supprimer votre demande d'événement ?",
      buttons: {
        confirm: 'Oui',
        cancel: 'Non',
      },
    },
    cancel_event_modal: {
      title: "Annuler l'événement",
      message: "Êtes-vous sûr de vouloir annuler votre demande d'événement ?",
      buttons: {
        confirm: 'Oui',
        cancel: 'Non',
      },
    },
  },
}
